import React,{useContext} from "react";

//Components
import ContactNavbar from "../../components/ContactNavbar/ContactNavbar";
import Navbar from "../../components/Navbar/Navbar";
import BodyWorkFormScreen from "../../components/BodyWorkFormScreen/BodyWorkFormScreen";
import WhatsappButton from "../../components/WhatsappButton/WhatsappButton";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";

//Context
import { LoadingContext } from "../../context/LoadingContext";

const WorkFormScreen = ({ navbarData }) => {
  const { loading } = useContext(LoadingContext);

  return (
    <>
      {loading && <LoadingScreen />}
      <WhatsappButton />
      <ContactNavbar social={navbarData.data} />
      <Navbar />
      <BodyWorkFormScreen />
    </>
  );
};

export default WorkFormScreen;
